import { render, staticRenderFns } from "./DashboardAlertsDoc.vue?vue&type=template&id=7524ab36"
import script from "./DashboardAlertsDoc.vue?vue&type=script&lang=js"
export * from "./DashboardAlertsDoc.vue?vue&type=script&lang=js"
import style0 from "./DashboardAlertsDoc.vue?vue&type=style&index=0&id=7524ab36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports